import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@wds/modal';
import { Box } from '@wds/box';

const AppDetailsMedia = ({ media }) => {
  const [showModal, setShowModal] = useState(false);
  const imgRef = useRef(null);

  return (
    <Choose>
      <When condition={media.type === 'youtube'}>
        <div className="sm-app-directory-app-details__media-video-container">
          <iframe
            className="sm-app-directory-app-details__media-video-container-frame"
            data-testid="AppDetailsMedia__SelectedVideo"
            allowFullScreen
            src={media.url}
            title={media.altText}
          />
        </div>
      </When>
      <Otherwise>
        <div>
          <Box onClick={() => setShowModal(true)}>
            <img
              ref={imgRef}
              alt={media.altText}
              data-testid="AppDetailsMedia__SelectedImage"
              src={media.url}
              width="100%"
              height="auto"
            />
          </Box>
          <Modal show={showModal} size="xl" onClose={() => setShowModal(false)} closeButtonLabel="Close Image">
            <Modal.Body>
              <Box pt={3}>
                <img
                  alt={media.altText}
                  data-testid="AppDetailsMedia__SelectedImage"
                  className=""
                  src={media.url}
                  width="100%"
                />
              </Box>
            </Modal.Body>
          </Modal>
        </div>
      </Otherwise>
    </Choose>
  );
};

AppDetailsMedia.propTypes = {
  media: PropTypes.shape({
    type: PropTypes.string,
    url: PropTypes.string,
    altText: PropTypes.string,
  }).isRequired,
};

export default AppDetailsMedia;
